import { FC } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useStyles } from './styles';
import { thunkAllowViewerTurn } from '../../../../../../store/actions/Streaming.actions';

interface ViewerWaitingDialogItemPros {
    avatar: string;
    username: string;
}

const ViewerWaitingDialogItem: FC<ViewerWaitingDialogItemPros> = ({ avatar, username }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const selectViewer = () => {
        if (username) {
            dispatch(thunkAllowViewerTurn(username));
        }
    };

    return (
        <Grid
            container
            xs={12}
            justify="space-between"
            alignContent="center"
            alignItems="center"
            direction="row"
        >
            <Grid
                container
                item
                xs={7}
                justify="flex-start"
                alignContent="center"
                alignItems="center"
                direction="row"
            >
                <img
                    className={clsx(classes.avatar)}
                    src={avatar}
                    alt={t('{{username}} user waiting for turn', { username })}
                />
                <Typography className={classes.usernameText}>{username}</Typography>
            </Grid>

            <Button onClick={selectViewer} className={classes.chooseButton}>
                {t('Choose')}
            </Button>
        </Grid>
    );
};

export default ViewerWaitingDialogItem;
